module.exports = __webpack_public_path__ + "img/atm_local.eab57c15.svg";